/**
 * @file Manages the mode storage in local storage
 */

export type mode = {
  isKioskMode: boolean;
};

/**
 * Get the current mode
 */
export function get(): mode | null {
  const mode = window.localStorage.getItem('mode');

  if (mode) {
    return JSON.parse(mode);
  }

  return null;
}

/**
 * Set the mode
 *
 * @param mode
 */
export function set(mode: mode) {
  window.localStorage.setItem('mode', JSON.stringify(mode));
}

/**
 * Remove the mode
 */
export function remove() {
  window.localStorage.removeItem('mode');
}
